import type { Ownership, OwnershipRight, OwnershipSummary } from "../../state/ownership";
import { formatDate } from "./publicationsFormat";

/** Eén veld van een recht als tekst: KIK geeft tekst, de PDF-parser regels. */
export const field = (right: OwnershipRight, label: string): string => {
  const value = right.velden?.[label];
  return Array.isArray(value) ? value.join(", ") : (value ?? "");
};

export type RightRow = { kind: string; share: string; holder: string; detail: string };

/** De rechten als tabelregels. Van een natuurlijk persoon alleen de naam;
 * adres en geboortedatum uit de PDF horen niet in het rapport. */
export const rightRows = (summary: OwnershipSummary): RightRow[] =>
  (summary.rechten ?? []).map((right) => ({
    kind: field(right, "Soort recht") || right.titel || "",
    share: field(right, "Aandeel"),
    holder: field(right, "Naam gerechtigde"),
    detail: [
      field(right, "KvK-nummer") && `KvK ${field(right, "KvK-nummer")}`,
      field(right, "Statutaire zetel"),
    ]
      .filter(Boolean)
      .join(", "),
  }));

export const formatEuro = (amount: number) => `€ ${Math.round(amount).toLocaleString("nl-NL")}`;

/** "€ 250.000 (2019)", alleen het bedrag of alleen het jaar. */
export const purchaseLabel = (summary: OwnershipSummary): string => {
  const { koopsom_eur: amount, koopjaar: year } = summary;
  if (amount != null && year) return `${formatEuro(amount)} (${year})`;
  if (amount != null) return formatEuro(amount);
  return year ? String(year) : "";
};

/** De stand van de gegevens: actualiteit van het Kadaster, anders de
 * leverdatum; een geüploade PDF heeft geen van beide. */
export const asOfLabel = (row: Ownership): string => {
  const date = formatDate(row.currentAsOf || row.deliveredAt || null);
  return date ? `stand per ${date}` : "";
};
